<template>
  <div class="salesman-wrap">
    <el-button type="primary" class="addSalesmanBtn" @click="addSalesmanClick" v-if="auth_control.have_add_auth">新增业务员</el-button>
    <el-table
      v-if="tableData.length"
	    :data="tableData"
	    border
	    style="width: 100%"
	  >
	     <el-table-column
	      prop="user_name"
	      label="业务员姓名"
	      align="center"
      >
	    </el-table-column>
	    <el-table-column
	      prop="account"
	      label="业务员账号"
	      align="center"
      >
	    </el-table-column>
	    <el-table-column
	      prop="plaintext_password"
	      label="业务员密码"
	      align="center"
      >
	    </el-table-column>
	    <el-table-column
	      label="操作"
	      align="center"
      >
        <template slot-scope="scope">
        	 <span class="operation-text" @click="toDetailClick(scope.row.uuid)" v-if="auth_control.have_detail_auth">查看详情</span>
        	 <span class="operation-text" @click="eidtSalesmanClick(scope.row)" v-if="auth_control.have_edit_auth">编辑</span>
        	 <span class="operation-text" @click="deleteSalesmanClick(scope.row)" v-if="auth_control.have_delete_auth">删除</span>
        </template>
	    </el-table-column>
	  </el-table>
	  <div v-else class="noData">暂无业务员</div>
	  <common-pagination
		  :total="total"
      :page_size="page_size"
		   @size-change="handelPagesizeChange"
		   @page-change="handlePageChange"
		  ></common-pagination>
		<common-dialog
    :title="dialogTitle"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
		  <div v-if="type === 'add' || type=== 'edit'">
	      <div class="input-item">
	      	<label for="user_name" class="input-label">业务员姓名：</label>
				  <el-input v-model="form.user_name" id="user_name" placeholder="请输入业务员姓名"></el-input>
				</div>
				<div class="input-item">
	      	<label for="account" class="input-label">账号：</label>
				  <el-input v-model="form.account" id="account" placeholder="请输入账号"></el-input>
				</div>
				<div class="input-item">
	      	<label for="plaintext_password" class="input-label">密码：</label>
				  <el-input v-model="form.plaintext_password" id="plaintext_password" placeholder="请输入密码"></el-input>
				</div>
			</div>
			<div v-else class="delete-text">是否删除业务员？</div>
		</common-dialog>
  </div>
</template>

<script>
import CommonPagination from '@/components/CommonPagination';
import CommonDialog from '@/components/CommonDialog';
import { salesmanlist, addSalesman, editSalesman, deleteSalesman } from '@/api/business-manage';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'salesmanlist',
  data() {
  	return {
      total: 0,
      page_index: '1',  //第几页
  		page_size: '10',
      tableData: [
        {user_name: '张三', account: 'sdsadadsd', plaintext_password:'11232q3q2'}
      ],
      dialogTitle: '',
      dialogVisible: false,
      type: '',
      form: {
      	user_name: '',
      	account: '',
      	plaintext_password: '',
      },
      three_rules: [],
      auth_control: {   //是否具有新增、详情、编辑、删除权限
        have_add_auth: false,
        have_detail_auth: false,
        have_edit_auth: false,
        have_delete_auth: false,
      }
  	}
  },
  computed: {
    ...mapState(['operationList']),
  },
  components: {
    CommonPagination,
    CommonDialog
  },
  mounted() {
    this.getSalesmanList();
    this.handleThreeRules();
  },
  methods: {
    ...mapActions(['updateSalesmanList']),
    async getSalesmanList() {
    	let postData = {
    		page_index: this.page_index,
    		page_size: this.page_size
    	};
    	const { data, status } = await salesmanlist(postData);
    	if (status !== 200) return
    	this.tableData = data.data;
      this.total = data.total;
    	console.log(data, '业务员列表')

    },
  	handelPagesizeChange(size) {
  		this.page_size = size;
  	},
  	handlePageChange() {
      this.page_index = page;
  	},
  	addSalesmanClick() {
      this.dialogTitle = '编辑/添加业务员';
  		this.dialogVisible = true;
  		this.type = 'add';
  	},
  	dialogCancelClick() {
  		this.dialogVisible = false;
  	},
  	dialogClose() {
      this.dialogVisible = false;
      this.form = {};
      this.getSalesmanList();
  	},
  	eidtSalesmanClick(row) {
  		this.type = 'edit';
      this.dialogTitle = '编辑/添加业务员';
  		//拷贝一份row赋值给form 直接赋值在修改时会对表格数据产生联动
  		this.form = JSON.parse(JSON.stringify(row));
  		this.dialogVisible = true;
  	},
  	deleteSalesmanClick(row) {
  		this.type = 'delete';
  		this.dialogTitle = '删除业务员';
      this.dialogVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
  	},
  	async dialogConfirmClick() {
       switch(this.type)  {
          case 'add':
            //非空验证
            const { user_name, account, plaintext_password} = this.form;
	          if (user_name === "" || account === "" || plaintext_password==="" ) {
           	  this.$message('内容不能为空');
           	  break;
	          }
           const { status }= await addSalesman(this.form);
           if (status === 200) {
            this.updateSalesmanList();
           	this.dialogVisible = false;
           	//成功后把数据清空
           	this.form = {};
           	this.getSalesmanList();
           }
            break;
          case 'edit':
            //块作用域 否则会与前面变量重复
            {
            	//非空验证
	            const { user_name, account, plaintext_password} = this.form;
		          if (user_name === "" || account === "" || plaintext_password==="" ) {
	           	  this.$message('内容不能为空');
	           	  break;
		          }
            	const { status } = await editSalesman(this.form);
            	if (status === 200) {
                this.updateSalesmanList();
            		this.dialogVisible = false;
		           	//成功后把数据清空
		           	this.form = {};
              }
              break;
            }
          case 'delete': 
            {
              const { uuid } = this.form;
              const { status } = await deleteSalesman(uuid);
              if (status !== 200) break
              this.dialogVisible = false;
              this.form = {};
            }
            break;
       }
  	},
  	toDetailClick(uuid) {
  		this.$router.push({
  			path: '/salesman-list/salesman-detail',
  			query: {
  				uuid,
  			}
  		})
  	},
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      this.three_rules.forEach(item => {
        if (item.menu_name.indexOf('详情') !== -1) {
          this.auth_control.have_detail_auth = true;
        }
        if (item.menu_name.indexOf('编辑') !== -1) {
          this.auth_control.have_edit_auth = true;
        }
        if (item.menu_name.indexOf('新增') !== -1) {
          this.auth_control.have_add_auth = true;
        }
        if (item.menu_name.indexOf('删除') !== -1) {
          this.auth_control.have_delete_auth = true;
        }
      })
      console.log(this.three_rules, 'three rulesssss')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.addSalesmanBtn {
	float: right;
	margin: 20px 0 30px;
}
.operation-text {
	color: @color-text;
	margin-right: 15px;
	cursor: pointer;
}
.noData {
	clear: both;
	text-align: center;
}
.input-item {
	margin-bottom: 15px;
	.input-label {
		display: inline-block;
		margin-bottom: 10px;
	}
}
.delete-text {
	text-align: center;
}
</style>
